import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: () => import('@/pages/home/home'),
      meta: {title: '导航页', icon: 'homeindex'},
      children: [
        {
          path: '/',
          name: 'index',
          component: () => import('@/pages/index/index'),
          meta: {title: '首页', icon: 'homeindex'}
        },
        {
          path: '/about',
          name: 'about',
          component: () => import('@/pages/about/about'),
          meta: {title: '关于我们', icon: 'homeindex'}
        },
        {
          path: '/info',
          name: 'info',
          component: () => import('@/pages/information/information'),
          meta: {title: '兆信资讯', icon: 'homeindex'}
        },
        {
          path: '/infodetails',
          name: 'infodetails',
          component: () => import('@/pages/infodetails/infodetails'),
          meta: {title: '资讯详情', icon: 'homeindex'}
        },
        {
          path: '/plan',
          name: 'plan',
          component: () => import('@/pages/solution/solution'),
          meta: {title: '解决方案', icon: 'homeindex'}
        },
        {
          path: '/product',
          name: 'product',
          component: () => import('@/pages/product/product'),
          meta: {title: '产品功能', icon: 'homeindex'}
        },
        {
          path: '/case',
          name: 'case',
          component: () => import('@/pages/case/case'),
          meta: {title: '客户案例', icon: 'homeindex'}
        },
      ]
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js